import {Component, Injector, Input, OnInit} from '@angular/core';
import { ObjectsService } from "../../../../services/objects.service";
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import {IconViewModel} from "../../../../models/IconViewModel";
import {ObjectModel} from "../../../../models/ObjectModel";

@Component({
    selector: 'app-object-icon-dialog',
    templateUrl: './object-icon-dialog.component.html',
    styleUrls: ['./object-icon-dialog.component.css'],
    standalone: false
})
export class ObjectIconDialogComponent extends DialogBaseComponent<ObjectModel> implements OnInit {
  private objectsService: ObjectsService;

  @Input('objectsArr')
  public objectsArr: ObjectModel[] = [];

  public Icons: IconViewModel[] = [];

  constructor(protected injector: Injector) {
    super(injector);

    this.objectsService = injector.get(ObjectsService);
  }

  ngOnInit()
  {
    this.model = this.objectsArr[0];

    this.objectsService.GetIcons()
      .subscribe(icons => {
        this.Icons = icons;
      });
  }

  public submit()
  {
    this.objectsService.SetObjectsIcon(this.objectsArr, this.model.Icon)
      .subscribe(() => {
        this.close();
        super.submit();
      });
  }

  public onColorSelected(event) {
    //this.model.Color = event;
  }

  public onIconChange(icon: IconViewModel) {
    this.model.Icon = icon;
  }

}
